import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.svg";
import { toast, ToastContainer } from "react-toastify";
import { Url } from "../config/config";
import axios from "axios";

export default function Login() {
  const history = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setError] = useState({ email: "" });

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (!email) {
      formIsValid = false;
      errors["email"] = "Please enter registerd Email Id";
    }
    setError(errors);
    return formIsValid;
  };
  //toast.configure();
  const handelForgotPassword = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      const res = await axios({
        url: `${Url}/sendLink`,
        method: "POST",
        data: {
          email,
        },
      });
      // console.log(res.data.data.token);
      //  return false;
      if (res.data.status === 200) {
        // history("/reset-password/" + res.data.data.token);
        toast.success(
          "Please check your email inbox. Password reset instructions sent to the associated email address."
        );
      } else if (res.data.status === 419) {
        toast.error("Email id is not registerd");
      } else {
        toast.error("Something went to wrong");
      }
    }
    //
  };
  return (
    <React.Fragment>
      <title>Volt | Forgot Password</title>
      <div className="LoginArea">
        <form method="POST">
          <div className="LoginBox">
            <figure>
              <img src={Logo} />
            </figure>
            <h5>Forgot Password</h5>
            <h6>
              Please enter you registered email id.<br></br> We will send you
              link to create new password.
            </h6>

            <div className="form-group">
              <label>Email</label>
              <input
                type="text"
                placeholder="Enter Email Id"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span className="Icon">
                <i className="fa fa-user"></i>
              </span>
              <span style={{ color: "red" }}>{errors.email}</span>
            </div>

            <button onClick={handelForgotPassword}>
              Forgot Password <i className="fa fa-sign-in"></i>
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}
